 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account-setting":"account-setting","admin-storage-aws-s3":"admin-storage-aws-s3","cadastro":"cadastro","create-school~edit-school~new-subscription-plan~subscription-plans":"create-school~edit-school~new-subscription-plan~subscription-plans","create-school":"create-school","edit-school":"edit-school","new-subscription-plan":"new-subscription-plan","subscription-plans":"subscription-plans","lockscreen":"lockscreen","login":"login","new-user":"new-user","pass-recovery":"pass-recovery","pdfjsWorker":"pdfjsWorker","profile":"profile","subscriptions":"subscriptions","users-schools":"users-schools","users-users":"users-users"}[chunkId]||chunkId) + "." + {"account-setting":"2c927bbc","admin-storage-aws-s3":"244ef0ef","cadastro":"337e8622","chunk-0b909644":"8bf23b25","chunk-0d925bb7":"0176c6ab","chunk-1b502ea3":"091f933b","chunk-258bf1ec":"25b5a787","chunk-2b0e5aa4":"47134246","chunk-30189c74":"bef9516a","chunk-3da8bc34":"c4742d7c","chunk-438a9ec1":"25abaaa0","chunk-53d623bb":"352ef9f9","chunk-7320a95b":"c853e372","chunk-e4f0a67a":"81d552c2","chunk-788d82cc":"6dcc7c25","chunk-d91cf2da":"664f1efd","create-school~edit-school~new-subscription-plan~subscription-plans":"e20c2e31","create-school":"6b7501f7","edit-school":"71ab5e0d","new-subscription-plan":"34bfe739","subscription-plans":"257e6d08","lockscreen":"ccef4602","login":"abe26767","new-user":"fe82e860","pass-recovery":"774f7d13","pdfjsWorker":"0431f44b","profile":"e8d00285","subscriptions":"fb187094","users-schools":"fd807450","users-users":"a0f01665","chunk-30b56856":"e85c7f3d","chunk-2d0daf15":"7f8b7e07","chunk-5d1a57b2":"32c2184b","chunk-2d22458c":"16dcae05","chunk-6d91a3bb":"553f27f0","chunk-19acb0dc":"4c0dac08","chunk-2d0e51ff":"3101fd95"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account-setting":1,"cadastro":1,"chunk-0b909644":1,"chunk-0d925bb7":1,"chunk-1b502ea3":1,"chunk-2b0e5aa4":1,"chunk-30189c74":1,"chunk-3da8bc34":1,"chunk-438a9ec1":1,"chunk-7320a95b":1,"chunk-e4f0a67a":1,"chunk-d91cf2da":1,"create-school":1,"edit-school":1,"new-subscription-plan":1,"subscription-plans":1,"login":1,"new-user":1,"profile":1,"subscriptions":1,"users-schools":1,"users-users":1,"chunk-30b56856":1,"chunk-5d1a57b2":1,"chunk-6d91a3bb":1,"chunk-19acb0dc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account-setting":"account-setting","admin-storage-aws-s3":"admin-storage-aws-s3","cadastro":"cadastro","create-school~edit-school~new-subscription-plan~subscription-plans":"create-school~edit-school~new-subscription-plan~subscription-plans","create-school":"create-school","edit-school":"edit-school","new-subscription-plan":"new-subscription-plan","subscription-plans":"subscription-plans","lockscreen":"lockscreen","login":"login","new-user":"new-user","pass-recovery":"pass-recovery","pdfjsWorker":"pdfjsWorker","profile":"profile","subscriptions":"subscriptions","users-schools":"users-schools","users-users":"users-users"}[chunkId]||chunkId) + "." + {"account-setting":"e4426343","admin-storage-aws-s3":"31d6cfe0","cadastro":"2be86921","chunk-0b909644":"eff8a4da","chunk-0d925bb7":"729cc1a8","chunk-1b502ea3":"4f636636","chunk-258bf1ec":"31d6cfe0","chunk-2b0e5aa4":"434815c8","chunk-30189c74":"99ac38a9","chunk-3da8bc34":"798cdb4f","chunk-438a9ec1":"52cd22c0","chunk-53d623bb":"31d6cfe0","chunk-7320a95b":"cd31990a","chunk-e4f0a67a":"8f1492a0","chunk-788d82cc":"31d6cfe0","chunk-d91cf2da":"3cafcdeb","create-school~edit-school~new-subscription-plan~subscription-plans":"31d6cfe0","create-school":"0bf22e85","edit-school":"72a21923","new-subscription-plan":"352236b0","subscription-plans":"34256dd5","lockscreen":"31d6cfe0","login":"9ec21b98","new-user":"cc44c300","pass-recovery":"31d6cfe0","pdfjsWorker":"31d6cfe0","profile":"eaf8c39d","subscriptions":"ef01124c","users-schools":"a416e726","users-users":"98590f63","chunk-30b56856":"970c026b","chunk-2d0daf15":"31d6cfe0","chunk-5d1a57b2":"31f800d4","chunk-2d22458c":"31d6cfe0","chunk-6d91a3bb":"534575c8","chunk-19acb0dc":"81d5b560","chunk-2d0e51ff":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
